import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SynchronizationResolver } from '../utils/syncronization.resolver';
import { environment } from '../../environments/environment';
import { MachineDetailPageComponent } from './pages/detail/machine-detail-page.component';
import { CustomerMachinesPageComponent } from './pages/customer-list/customer-machines-page.component';
import { NewMachinePageComponent } from './pages/new/new-machine-page.component';
import { EditMachinePageComponent } from './pages/edit/edit-machine-page.component';
import { InspectionListPageComponent } from '../inspections/pages/list.component';

const routes: Routes = [
  {
    path: '',
    resolve: { synchronizeData: SynchronizationResolver },
    children: [
      {
        path: environment.applicationRoute + '/machines/:machineSerial/inspections',
        component: InspectionListPageComponent
      },
      {
        path: environment.applicationRoute + '/customers/:clientNumber/machines',
        component: CustomerMachinesPageComponent
      },
      {
        path: environment.applicationRoute + '/customers/:clientNumber/machines/new',
        component: NewMachinePageComponent
      },
      {
        path: environment.applicationRoute + '/machines/:machineSerial/edit',
        component: EditMachinePageComponent
      },
      {
        path: environment.applicationRoute + '/machines/:machineSerial',
        component: MachineDetailPageComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MachinesRoutingModule {}
